import React from 'react';

import { useCountry } from '@lt/localization';
import { HotelCounter } from 'src/components/HotelCounter';
import styled from 'styled-components';

import type { SearchType } from 'src/types/search';
import type { IBrowser } from 'redux-responsive';

import LazyPriceChart from '../PriceChart/LazyPriceChart';
import Title from '../Title';
import Sorting from '../Sorting';

export interface HeaderPropsType {
  browser: IBrowser;
  fullMapView: boolean;
  searchType: SearchType;
  hotelsCount: number;
  isEmptySearch: boolean;
  isHotelOnly: boolean;
  firstResultsFetched: boolean;
  awaitFiltration: boolean;
}

/**
 * Шапка страницы поиска, где содержится заголовок, гребенка и сортировка
 */
const SearchPageHeader = ({
  browser,
  fullMapView,
  hotelsCount,
  searchType,
  isEmptySearch,
  isHotelOnly,
  firstResultsFetched,
  awaitFiltration,
}: HeaderPropsType): JSX.Element => {
  const { isRussia } = useCountry();

  const notFullMapView =
    browser.greaterThan.large || (browser.lessThan.extraLarge && !fullMapView);

  const isShowSorting = Boolean(
    !isEmptySearch && firstResultsFetched && notFullMapView,
  );

  const isShowPriceChart = isRussia && !isHotelOnly;

  const isShowTitle = !isEmptySearch;

  return (
    <Container>
      {isShowTitle && <StyledTitle />}

      {isShowPriceChart && <PriceChart />}

      {isShowSorting && (
        <SubtitleContainer>
          <Sorting />

          <HotelCounter
            hotelCounter={hotelsCount}
            searchType={searchType}
            loading={awaitFiltration}
          />
        </SubtitleContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled(Title)`
  margin-bottom: 8px;
`;

const PriceChart = styled(LazyPriceChart)`
  margin-bottom: 16px;
`;

const SubtitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 12px;
`;

export default SearchPageHeader;
